<div
  *ngIf="renderTrigger"
  class="_auth-container"
  [ngClass]="{ '_auth-container--wl-mode': wlMode }"
>
  <ng-container [ngSwitch]="!!user">
    <div
      *ngSwitchDefault
      class="bm-header-btn-wrapper _auth-buttons"
      [ngClass]="{ 'bm-header-btn-wrapper--wl-mode': wlMode }"
    >
      <button
        class="open-auth-modal"
        [ngClass]="{
          'bm-open-button--text': !boxBtnMode,
          'bm-open-button--box bordered': boxBtnMode,
          standalone
        }"
        *ngIf="!standalone"
        (click)="showSignUpDialogHandler()"
      >
        <span class="label"
          >Login or Sign Up
          <!--        [translate]="'sign-up'"-->
        </span>
      </button>
      <button
        *ngIf="standalone"
        appBrightrButton
        (click)="showSignUpDialogHandler()"
      >
        <span
          >Login or Sign Up
          <!--        [translate]="'sign-up'"-->
        </span>
      </button>
    </div>

    <div
      *ngSwitchCase="true"
      class="bm-header-btn-wrapper _auth-buttons"
      [ngClass]="{ 'bm-header-btn-wrapper--wl-mode': wlMode }"
    >
      <ng-container [ngSwitch]="mobileInfoShow">
        <div
          *ngSwitchDefault
          class="_user user-info-block"
          [ngClass]="{
            '_user--core-mode': !wlMode,
            standalone,
            '_user--white-mode': whiteMode,
            '_user--passports-mode': checkInPage
          }"
        >
          <ng-container *ngIf="!checkInPage">
            <span
              class="_user__name"
              *ngIf="user.firstName && user.firstName.length > 0"
            >
              {{ user.firstName }}
            </span>
            <span
              class="_user__name"
              *ngIf="
                !user.firstName ||
                (user.firstName && user.firstName.length === 0)
              "
            >
              {{ profile.phone }}
            </span>
          </ng-container>
          <ng-container *ngIf="checkInPage">
            <a
              class="_user__passports"
              [routerLink]="['/your-passports']"
              [target]="'_blank'"
              [class._white-mode]="whiteMode"
            >
              <span [translate]="'check-in.header-auth-passports'"></span>
              <i class="counter" *ngIf="counts.yPassports > 0">
                {{ counts.yPassports }}
              </i>
            </a>
          </ng-container>
          <button (click)="logout()">
            <mat-icon svgIcon="custom:logout-v2"></mat-icon>
          </button>
        </div>

        <div
          *ngSwitchCase="true"
          class="_mobile-user-info"
          [ngClass]="{ '_mobile-user-info--wl-mode': wlMode }"
        >
          <div class="_user-photo">
            <div
              class="_user-photo__img"
              *ngIf="user.image"
              [ngStyle]="getImage(false)"
            ></div>
            <div class="_user-photo__name">
              {{ user.firstName + ' ' + user.lastName }}
            </div>
          </div>
          <div class="_qr-content">
            <qrcode
              [qrdata]="'gobcnme://c/' + user.username"
              [colorDark]="appConfig.settings.main_color"
              [size]="256"
              [level]="'M'"
            ></qrcode>
            <div class="_qr-content__photo"></div>
          </div>
          <div class="_info-learn">
            <span class="_info-learn__more"
              >{{ 'learn-more-info' | translate }}
              <i
                class="_info-icon"
                [attr.aria-label]="'universal-id-about' | translate"
                matTooltip="{{ 'universal-id-about' | translate }}"
              ></i
            ></span>
          </div>
        </div>
      </ng-container>

      <div
        class="_popup-container"
        (clickOutside)="onClickedOutside()"
        *ngIf="opened"
      >
        <div class="_popup-container__window">
          <div class="_popup-content">
            <div class="_popup-content__header">
              <span class="_popup-content__header__user-name">
                {{ user.firstName + ' ' + user.lastName }}
              </span>
              <button class="bm-button bm-link" (click)="logout()">
                Logout
              </button>
            </div>
            <div class="_qr-content">
              <qrcode
                [qrdata]="'gobcnme://c/' + user.username"
                [colorDark]="appConfig.settings.main_color"
                [size]="256"
                [level]="'M'"
              ></qrcode>
              <div class="_qr-content__photo"></div>
            </div>
            <div class="_popup-content__footer">
              <span class="_learn-more"
                >{{ 'learn-more-info' | translate }}
                <i
                  class="_info-icon"
                  [attr.aria-label]="'universal-id-about' | translate"
                  matTooltip="{{ 'universal-id-about' | translate }}"
                ></i
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!--Sign Up Modal-->
<app-modal
  *ngIf="renderModal && showSignUpDialog"
  [visible]="showSignUpDialog"
  [isSmall]="true"
  (modalClickOutside)="modalViewClose()"
>
  <div class="auth-modal-content">
    <div class="close" (click)="modalViewClose()">
      <mat-icon svgIcon="custom:close"></mat-icon>
    </div>

    <div class="step-container" *ngIf="signUpStep === steps.PhoneInputStep">
      <div class="title">
        Login or Sign Up
        <!--        [translate]="'sign-up'"-->
      </div>
      <div class="info">
        Please enter your mobile phone number to login or sign up. You will
        receive an SMS with a 4 digit confirmation code.
        <!--        [translate]="'sign-up-phone-info'"-->
      </div>
      <div class="bm-input-container">
        <app-bt-phone-input
          [parentFormControl]="phoneSignUpControl"
          [readonly]="signUpStep !== steps.PhoneInputStep"
        ></app-bt-phone-input>
        <div class="bm-invalid-text-input" *ngIf="firstStepSignUpInValid">
          {{ 'invalid' | translate }}
        </div>
        <div class="_error-container" *ngIf="errorMessage?.length">
          {{ errorMessage }}
        </div>
      </div>
      <button
        appBrightrButton
        [color]="'primary'"
        [size]="'md'"
        (click)="signUpNext()"
        [loading]="loading"
      >
        <span>{{ 'next' | translate }}</span>
        <mat-icon svgIcon="custom:chevron-right"></mat-icon>
      </button>
      <!--      <button class="bm-button bordered fb-login" (click)="loginFb('sign-up')">-->
      <!--        {{ 'sign-up-with-fb' | translate }}-->
      <!--      </button>-->
    </div>
    <div
      class="step-container name-step"
      *ngIf="signUpStep === steps.NameInputStep"
    >
      <div class="title lock">
        {{ phoneSignUpControl.value | phone }}
      </div>
      <div class="info">
        <!--        [translate]="'sign-up-info'"-->
        <!--        [translateParams]="{-->
        <!--        val: '+' + phoneSignUpControl.value | phone-->
        <!--        }"-->
        Please enter your name to finish the sign up process for
        {{ phoneSignUpControl?.value | phone }}.
      </div>
      <div class="bm-input-container">
        <input
          #nameInput
          [formControl]="nameControl"
          class="input"
          type="text"
          spellcheck="false"
          appAutoFocus
          placeholder="First Name"
        />
      </div>
      <div class="bm-input-container">
        <input
          #lastNameInput
          [formControl]="lastNameControl"
          class="input"
          type="text"
          spellcheck="false"
          placeholder="Last Name"
        />
      </div>
      <div class="_error-container" *ngIf="errorMessage?.length">
        {{ errorMessage }}
      </div>
      <button class="bm-button colored green" (click)="signUpNext(true)">
        {{ 'sign-up' | translate }}
      </button>
    </div>
    <div
      class="step-container confirm-step"
      *ngIf="signUpStep === steps.ConfirmStep"
    >
      <div class="_loading-container" *ngIf="loading">
        <mat-spinner class="spinner"></mat-spinner>
      </div>
      <!--      <button-->
      <!--        class="bm-button back-button"-->
      <!--        appSetBackground-->
      <!--        (click)="backStep()"-->
      <!--      ></button>-->
      <div class="title lock">
        <mat-icon svgIcon="custom:edit-i" (click)="backStep()"></mat-icon>
        {{ phoneSignUpControl.value | phone }}
      </div>
      <div class="info">
        <!--        [translate]="'enter-code'"-->
        <!--        [translateParams]="{ val: '+' + phoneSignUpControl.value }"-->
        Enter the code we sent to {{ phoneSignUpControl?.value }} to confirm
        your phone number.
      </div>
      <div class="bm-code-inputs-group" [formGroup]="codeGroup">
        <input
          formControlName="code1"
          #code1
          appAutoFocus
          type="tel"
          (keyup)="verify($event, 1)"
          required
          mask="0"
        />
        <input
          formControlName="code2"
          #code2
          type="tel"
          (keyup)="verify($event, 2)"
          required
          mask="0"
        />
        <input
          formControlName="code3"
          #code3
          type="tel"
          (keyup)="verify($event, 3)"
          required
          mask="0"
        />
        <input
          formControlName="code4"
          #code4
          type="tel"
          (keyup)="verify($event, 4, true)"
          required
          mask="0"
        />
      </div>
      <div class="_error-container" *ngIf="errorMessage?.length">
        Invalid code entered. Please try again.
      </div>
      <div class="resend" [class._error]="errorMessage?.length">
        <span class="text" [translate]="'have-not-receive'"></span>
        <span
          (click)="resend('sign-up')"
          class="bm-link"
          [translate]="'resend'"
        ></span>
      </div>
    </div>
    <div class="secure" *ngIf="signUpStep === steps.PhoneInputStep">
      <mat-icon svgIcon="custom:done"></mat-icon>
      <span>{{ 'never-pass' | translate }}</span>
    </div>
  </div>
  <section class="_terms-section" *ngIf="false">
    <a
      class="_item"
      (click)="clickAnalyticSend('pp')"
      [routerLink]="['/privacy-policy']"
    >
      {{ 'footer--privacy-policy' | translate }}
    </a>
    <a
      class="_item"
      (click)="clickAnalyticSend('tos')"
      [routerLink]="['/terms-of-service']"
    >
      {{ 'footer--terms-of-service' | translate }}
    </a>
  </section>
</app-modal>
